import { render, staticRenderFns } from "./MultimediaMessageForm.vue?vue&type=template&id=f771afc8&scoped=true&"
import script from "./MultimediaMessageForm.vue?vue&type=script&lang=js&"
export * from "./MultimediaMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./MultimediaMessageForm.vue?vue&type=style&index=0&id=f771afc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f771afc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VIcon,VRow})
